'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, Modal } from 'external/react-bootstrap';
import '../css/_modal.scss';

const TitleContainerContext = React.createContext(null);

/**
 * Wraps content (children) into a modal-container with header, and footer.
 */
class CustomModal extends React.Component {

  constructor(props) {
    super(props);
    this.setTitleRef = element => {
      this.titleRef = element;
      this.setState({
        titleRefSet: true
      });
    };
  }

  getChildContext() {
    return { contextId: (this.context && this.context.contextId && this.context.contextId + '_Modal') || this.props.context && (this.props.context.contextId + '_Modal') };
  }

  render() {
    const { show, onHide, children, hideFooter, aboveLiferayDialog = false, size = 'lg', className = '' } = this.props;
    const classNames = `${className}${aboveLiferayDialog ? ' above-liferay-dialog' : ''}`;
    return (
      <Modal
        backdrop="static"
        show={show}
        size={size}
        onEscapeKeyDown={onHide}
        onHide={onHide}
        animation={false}
        backdropClassName={aboveLiferayDialog ? 'above-liferay-backdrop' : ''}
        className={classNames}
        scrollable
        centered
      >
        <Modal.Header closeLabel="Modal Schließen">
          <h3 className={'modal-title'} ref={this.setTitleRef}/>
          <Button
            variant="outline-primary"
            onClick={onHide}
            className="custom-close"
          >
            <span className="fa fa-times"/>
          </Button>
        </Modal.Header>

        <TitleContainerContext.Provider value={this.titleRef}>
          {children}
        </TitleContainerContext.Provider>

        {
          !hideFooter &&
          <CustomModalFooter onHide={onHide}/>
        }
      </Modal>
    );
  }
}

const CustomModalFooter = ({ children, onHide }) => (
  <Modal.Footer>
    {
      !children &&
      <Button variant="primary" type="button" onClick={onHide}>
        Schließen
      </Button>
    }
    {children && children}
  </Modal.Footer>
);

const CustomModalBody = React.forwardRef(({ children }, ref) => (
  <Modal.Body ref={ref}>
    {children}
  </Modal.Body>
));

CustomModal.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string,
  onHide: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ]),
  aboveLiferayDialog: PropTypes.bool,
  size: PropTypes.string,
  hideFooter: PropTypes.bool,
  context: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};

CustomModal.childContextTypes = {
  contextId: PropTypes.string
};

CustomModalFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ]),
  onHide: PropTypes.func
};

CustomModalBody.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ])
};

export { CustomModal, CustomModalFooter, CustomModalBody, TitleContainerContext };



// WEBPACK FOOTER //
// ./js/components/CustomModalComponents.jsx